export const getOfferIdFromPolicyNo = {
    source: 'data',
    route: '/contract/offers/blob/overview/search',
    method: 'GET',
    processResponse: (res) => res[0]?.id,
};
